import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getMTDYTDClientRRGoalsRequest: ['clientId', 'timezoneOffset'],
  getMTDYTDClientRRGoalsSuccess: ['response'],
  getMTDYTDClientRRGoalsFailure: null,

  createClientGoalForBonusRequest: ['clientId', 'payload'],
  createClientGoalForBonusSuccess: ['response'],
  createClientGoalForBonusFailure: ['clientId'],

  updateClientGoalForBonusRequest: ['clientId', 'goalId', 'payload'],
  updateClientGoalForBonusSuccess: ['response'],
  updateClientGoalForBonusFailure: ['clientId'],

  // Clear all caches
  clearGoalsRequest: null,
});

export const GoalsTypes = Types;
export default Creators;
